// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-number-module__stepTitle--BH5rK{margin-bottom:5px}.phone-number-module__stepSubtitle--34uaB{margin-bottom:20px}.phone-number-module__inputError--E-tTS{position:relative;padding-top:5px}.phone-number-module__actionButtons--1ASmh{display:flex;flex-direction:column-reverse;gap:10px;margin-top:20px}@media screen and (min-width:1152px){.phone-number-module__actionButtons--1ASmh{flex-direction:row}}.phone-number-module__actionButton--7cRPV{width:100%}", ""]);
// Exports
exports.locals = {
	"stepTitle": "phone-number-module__stepTitle--BH5rK",
	"stepSubtitle": "phone-number-module__stepSubtitle--34uaB",
	"inputError": "phone-number-module__inputError--E-tTS",
	"actionButtons": "phone-number-module__actionButtons--1ASmh",
	"actionButton": "phone-number-module__actionButton--7cRPV"
};
module.exports = exports;
